import { styled, alpha, Typography } from '@mui/material';

export const Root = styled('li')({
  display: 'flex !important',
  flexDirection: 'row',
});

export const ReferenceTag = styled(Typography)(({ theme }) => ({
  background: alpha(theme.palette.text.primary, 0.12),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}));
